module.exports = __webpack_public_path__ + "static/media/serviceLevelAgreement.219bc1cb.svg";